﻿
import { NgModule } from '@angular/core';
import { Route, Router, RouterModule, Routes } from '@angular/router'

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AuthGuard } from '../shared/security/auth-guard.service';
import { SharedModule } from '../shared/shared.module';

import { HomeComponent } from './home.component';
import { HomeService } from './home.service';
import {SurveyComponent } from '../survey/survey.component';

const appRoutes: Routes = [
    {
        path: '',
        component: HomeComponent,
        data: { breadcrumb: 'home' }
    }
  
];



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forRoot(appRoutes),


        SharedModule,

    ],
    entryComponents: [
        //add dynamic components here (eg. components used by ngbModal)
    ],
    declarations: [
        HomeComponent,
    ],
    exports: [
        RouterModule,
    ],
    providers: [
        //add services to export here
        HomeService
    ]

})
export class HomeModule { }
